enum FontType{
    NotoSerifSC = "Noto Serif SC",
    Roboto = "Roboto",
    Benne = "Benne",
    MaShanZheng = "Ma Shan Zheng",
    LongCang = "Long Cang",
    Acme = "Acme",
    PatrickHand = "patrick hand",
    PermanentMarker = "permanent marker"
}

export default FontType;